/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseTemplateDto } from '../../models/base-template-dto';
import { CreateModelRequest } from '../../models/create-model-request';

export interface CreateModel$Params {
      body: CreateModelRequest
}

export function createModel(http: HttpClient, rootUrl: string, params: CreateModel$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseTemplateDto>> {
  const rb = new RequestBuilder(rootUrl, createModel.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseTemplateDto>;
    })
  );
}

createModel.PATH = '/v0/FocoosAI/model';
